
const TrustMarquee = () => {
  const metrics = [
    { value: "160%", label: "同期營收增長" },
    { value: "13hrs", label: "10:00-23:00 專人接單" },
    { value: "500+", label: "網紅合作" },
    { value: "60-95%", label: "專業客服接單滿房率" },
    { value: "多場域", label: "實績見證可 Demo" },
  ];

  return (
    <section data-testid="trust-marquee" className="bg-[#0A2540] py-4 md:py-6 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap">
        {[...metrics, ...metrics].map((metric, index) => (
          <div key={`${metric.value}-${index}`} className="flex items-center mx-5 md:mx-8">
            <span className="text-[#FF6B00] font-black text-xl md:text-3xl mr-2 md:mr-3">{metric.value}</span>
            <span className="text-white font-medium text-sm md:text-lg">{metric.label}</span>
            <span className="text-[#FF6B00] mx-5 md:mx-8">•</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustMarquee;
